import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { PrestoObjectDataset } from 'app/model/dataset/presto.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PrestoObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class PrestoObjectDatasetAdapter extends TabularTypeDatasetAdapter<PrestoObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: PrestoObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(PrestoObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: PrestoObjectDataset): Promise<PrestoObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, PrestoObjectDataset.MODEL);
    }
}
